/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useVoidClaim
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';
import { getClaimResponsePath } from 'utils/router';

/**
 * Mutate for void claim
 *
 */
interface IProps {
	voidRequestModel: ClaimRequest.IFHIRClaimApiVoidClaimRequest;
}
const useVoidClaim = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ voidRequestModel }) => {
			const { data } = await api.FHIRClaimApi.voidClaim(voidRequestModel);
			return data;
		},
		onSuccess: (data) => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimRequestById, { id: data?.claimId }] });
			AppEvents.publishRedirect({ url: getClaimResponsePath(data?.claimId) });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useVoidClaim;
